<ng-template #popContent><div [innerHTML]="content"></div></ng-template>
<a href="#" (click)="$event.preventDefault()" tabindex="-1" [popover]="popContent" placement="top" triggers="focus hover" class="icon"><i class="fa fa-info-circle" aria-hidden="true"></i></a>
